<script>
import { ref, watch } from 'vue'
import VueNextSelect from 'vue-next-select'

export default {
  components: {
    VueNextSelect,
  },
  props: {
    id: {
      type: String,
      default: Math.random().toString(36).substring(7),
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: String,
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const currentValue = ref('')

    watch(
      () => props.modelValue,
      (value) => {
        currentValue.value = value
      },
      {
        immediate: true,
      }
    )

    const valueChange = ({ value }) => {
      emit('update:modelValue', value)
      emit('change', value)
    }

    return {
      currentValue,
      valueChange,
    }
  },
}
</script>

<template>
  <div class="item form-group mb-0" :class="{ failed: error }">
    <label v-if="label" :for="id" class="form-control-label">
      {{ label }}
      <span v-if="required">*</span>
    </label>

    <VueNextSelect
      :searchable="options.length > 1"
      :options="options"
      label-by="label"
      value-by="value"
      :min="1"
      :search-placeholder="__('form.type_to_search')"
      :placeholder="__('form.choose')"
      :clear-on-close="true"
      :close-on-select="true"
      :disabled="disabled"
      v-model="currentValue"
      @selected="valueChange"
    />
  </div>
</template>

<style lang="scss" scoped>
.item {
  ::v-deep(.vue-select) {
    position: relative;

    &[data-visible-length='0'] {
      input {
        border-color: #dd1d20 !important;
      }
    }

    input {
      &::placeholder {
        color: #181818;
        opacity: 1;
      }

      &:-ms-input-placeholder {
        color: #181818;
      }

      &::-ms-input-placeholder {
        color: #181818;
      }

      &:focus {
        outline: none;
      }

      &:disabled {
        color: rgba(24, 24, 24, 0.5) !important;

        &::placeholder {
          color: rgba(24, 24, 24, 0.5) !important;
        }

        &:-ms-input-placeholder {
          color: rgba(24, 24, 24, 0.5) !important;
        }

        &::-ms-input-placeholder {
          color: rgba(24, 24, 24, 0.5) !important;
        }
      }
    }

    .vue-dropdown {
      display: none;
      position: absolute;
      top: 5rem;
      left: 0;
      width: 100%;
      max-height: 35rem;
      background-color: #eeeeee;
      overflow-y: auto;
      border-top: none;
      z-index: 3;
      list-style-type: none;
      margin: 0;
      padding: 0;
    }

    &[aria-expanded='true'] .vue-dropdown {
      display: unset;

      &[data-visible-length='0'] {
        display: none;
      }
    }

    .vue-dropdown-item {
      color: #181818;
      font-size: 1.6rem;
      padding: 0.75rem 1.75rem;
      cursor: pointer;

      &.selected,
      &.highlighted {
        color: #fff;
        background-color: #dd1d20;
      }
    }
  }
}
</style>
